/**
 * Dummy content generator
 */

    import _ from 'underscore';
    import Chance from 'chance';
    const chance = new Chance();
    import getSet from '../dummy/dummy-data';

    import config from '../../config';
    const assetsSubDirectory = process.env.NODE_ENV === 'production'
      ? config.build.assetsSubDirectory
      : config.dev.assetsSubDirectory

    const generator = {

        getSet,

        // Random string
        randomStringFromSet(key) {
            return _.sample(this.getSet(key));
        },

        // Get x amount of random items from set
        getRandomItemsFromSet(key, count = 3) {
            const set = this.getSet(key);
            const shuffled = set.sort(() => .5 - Math.random());
            return shuffled.slice(0, count);
        },

        // Get date
        getDate() {
            return `${chance.date({string: true})}`;
        },

        // Get name
        getName() {
            return `${ chance.name() }`
        },

        // Get name
        getStatus() {
            return _.sample(['Active', 'Inactive']);
        },

        // Get random number
        getRandomNumber(min = 0, max = 10) {
            return chance.natural({ min, max });
        },

        // Get profile picture url
        getProfilePictureUrl(gender, pictureId) {
            return `${assetsSubDirectory}/images/profile-pictures/${gender}/image-${pictureId}.png`;
        },

        randomString() {
            return `${chance.natural()}${chance.syllable()}`;
        },

        // Generate random pane content
        randomContentOfType(key, includes = {}) {
            const defaults = {
                id: `${chance.natural()}${chance.syllable()}`,
                includes,
            };
            switch (key) {

                // Order
                case 'order':
                    let order = {
                        type: 'order',
                        view: 'orders-view',
                        owner: 'orders',
                        name: this.randomStringFromSet('item_name'),
                        publisher: 'ACME Publishing Group',
                        vendor: this.randomStringFromSet('vendor'),
                        orderId: chance.natural({min: 10001, max: 99999}),
                        created: this.getDate(),
                        sent: this.getDate(),
                        user: this.getName(),
                        price: chance.dollar({ max: 1000 }),
                        items: chance.natural({min: 1, max: 20}),
                        ...defaults,
                    };

                    order['breadcrumb'] = `Order #${order.orderId}`;
                    order['sub'] = `${order.items} items ordered from ${order.publisher}`;
                    order['title'] = `${order.orderId}`;
                    order['headline'] = `Order No. ${order.orderId}`;

                    return order;
                break;

                // Item
                case 'item':
                    let item = {
                        type: 'item',
                        owner: 'items',
                        view: 'items-view',

                        name: this.randomStringFromSet('item_name'),
                        status: 'Available',
                        barcode: chance.natural({min: 1000000000000, max: 9999999999999}),
                        loan_type_permanent: 'Short-term loan',
                        loan_type_temporary: 'Short-term loan',
                        location_type_permanent: 'Short-term loan',
                        location_type_temporary: 'Short-term loan',
                        material_type: this.randomStringFromSet('resource_type'),
                        call_number: chance.ssn(),
                        language: 'English',

                        instanceCount: this.getRandomNumber(1, 3),

                        ...defaults,
                    }

                    item['title'] = `${item.name} - ${ item.material_type } - ${ item.language }`;
                    item['sub'] = `${item.call_number} - ${ item.barcode}`;
                    item['breadcrumb'] = `Item ${item.barcode}`;

                    return item;
                break;

                // Instance
                case 'instance':
                    let instance = {
                        type: 'instance',
                        owner: 'instances',
                        view: 'instances-view',

                        name: this.randomStringFromSet('item_name'),
                        subjects: ['Libray & information Science', 'Language arts and disciplines / Library', 'Information Science / General', 'Language arts & disciplines', 'Information science / digital & Online Resources'],
                        identifiers: ['ISBN: 978-1-7848383-4222-2 (paper)', '978-1-223-23-791-0 (cloth)'],
                        source: 'Local: Marc',
                        edition: '1st Edition',
                        publisher: this.randomStringFromSet('publisher'),
                        publication_date: this.getDate(),
                        resource_type: this.randomStringFromSet('resource_type'),
                        instance_id: chance.natural({min: 10001, max: 99999}),

                        packageCount: this.getRandomNumber(1, 3),

                        ...defaults,
                    }

                    instance['title'] = `${instance.name}`;
                    instance['breadcrumb'] = `Instance #${instance.instance_id}`;

                    return instance;
                break;

                // Package
                case 'package':
                    let _package = {
                        type: 'package',
                        owner: 'packages',
                        view: 'packages-view',
                        name: this.randomStringFromSet('package_title'),
                        holdings: this.randomStringFromSet('yes_no'),
                        source: 'External KB',
                        package_type: 'Aggregated Full-Text',
                        hide_all_titles: this.randomStringFromSet('yes_no'),
                        allow_ebsco: this.randomStringFromSet('yes_no'),
                        vendor: this.randomStringFromSet('vendor'),
                        proxy_server: 'Inherited',
                        titles: chance.natural({min: 1001, max: 4000}),
                        package_id: chance.fbid(),
                        instanceCount: this.getRandomNumber(10, 20),

                        ...defaults,
                    }
                    _package['title'] = `${_package.name}`;
                    _package['sub'] = `#${_package.package_id}`;
                    _package['breadcrumb'] = `${_package.name}`;

                    return _package;
                break;


                // User
                case 'user':
                    let user = {
                        type: 'user',
                        owner: 'users',
                        view: 'users-view',

                        profilePictureId: chance.integer({min: 1, max: 66}), // We have 66 predefined profile pictures
                        gender: chance.gender().toLowerCase(),
                        status: this.getStatus(),
                        patron_group: this.randomStringFromSet('patron_groups'),
                        loan_count: this.getRandomNumber(3, 10),
                        expiration_date: this.getDate(),

                        ...defaults,
                    }

                    user['profilePictureUrl'] = this.getProfilePictureUrl(user.gender, user.profilePictureId);
                    user['name'] = chance.name({ gender: user.gender })
                    user['firstname'] = user['name'].split(' ')[0];
                    user['lastname'] = user['name'].split(' ')[1];
                    user['title'] = `${user.lastname}, ${user.firstname}`;
                    user['breadcrumb'] = user.name;
                    user['username'] = `${user.firstname}${user.lastname}`.toLowerCase();


                    return user;
                break;

                // Loan
                case 'loan':
                    let loan = {
                        type: 'loan',
                        owner: 'users',
                        view: 'loans-view',

                        loan_id: this.getRandomNumber(5000, 10000),
                        item_type: this.randomStringFromSet('resource_type'),
                        item_name: this.randomStringFromSet('item_name'),
                        item_status: this.randomStringFromSet('item_status'),
                        loan_policy: _.sample(['14 days', '7 days', '30 days']),
                        loan_date: this.getDate(),
                        due_date: this.getDate(),
                        return_date: this.getDate(),
                        borrower: this.getName(),
                        authors: this.getRandomItemsFromSet('item_authors', 3),
                        barcode: chance.natural({min: 1000000000000, max: 9999999999999}),
                        fee_fine: chance.floating({min: 5, max: 100, fixed: 2 }),
                        call_number: this.randomString(),
                        location: this.randomStringFromSet('locations'),
                        renewal_count: this.getRandomNumber(),
                        request_queue: this.getRandomNumber(),
                        claim_returned: '-',
                        lost: '-',
                        ...defaults,
                    }

                    loan['breadcrumb'] = `Loan #${loan.loan_id}`;

                    return loan;
                break;


                // Loan actions
                case 'loan_action':
                    let loan_action = {
                        type: 'loan_action',
                        // owner: 'users',
                        // view: 'loans-view',

                        action_date: this.getDate(),
                        action: this.randomStringFromSet('loan_actions'),
                        desk: this.randomStringFromSet('desks'),
                        source: this.randomStringFromSet('sources'),
                        due_date: this.getDate(),
                        item_status: this.randomStringFromSet('item_status'),
                        ...defaults,
                    }

                    return loan_action;
                break;

                // Fee's 'n' fines
                case 'fee':
                    let fee = {
                        type: 'fee',
                        owner: 'users',
                        // view: 'loans-view',
                        due_date: this.getDate(),
                        charge_date: this.getDate(),
                        amount: chance.floating({min: 5, max: 100, fixed: 2 }),
                        fee_id: this.getRandomNumber(5000, 10000),
                        fee_type: this.randomStringFromSet('fee_type'),
                        fee_owner: this.randomStringFromSet('locations'),
                        fee_status: this.randomStringFromSet('fee_status'),
                        item_name: this.randomStringFromSet('item_name'),
                        item_type: this.randomStringFromSet('resource_type'),
                        barcode: chance.natural({min: 1000000000000, max: 9999999999999}),
                        call_number: this.randomString(),
                        ...defaults,
                    }

                    fee['charged'] = fee.amount;
                    fee['remaining'] = (fee['charged'] - chance.floating({min: 0, max: fee['charged'] - 4, fixed: 2 })).toFixed(2);
                    fee['breadcrumb'] = `Fee/fine ${ fee.fee_id }`;
                    return fee;
                break;

                // Fee actions
                case 'fee_action':
                    let fee_action = {
                        type: 'fee_action',
                        // owner: 'users',
                        // view: 'loans-view',

                        action_date: this.getDate(),
                        action: this.randomStringFromSet('fee_actions'),
                        balance: chance.floating({min: 5, max: 100, fixed: 2 }),
                        transaction_number: chance.natural({min: 1000000000000, max: 9999999999999}),
                        created_at: this.randomStringFromSet('locations'),
                        source: this.getName(),
                        notes: chance.paragraph({sentences: 1}),
                        ...defaults,
                    }

                    return fee_action;
                break;

                default:
                    console.warn('Collection with key', key, ' not found!')
                    return [];
            }
        },

        // Generate random list of items
        randomList(key, count, includes) {
            if (typeof count !== 'number') {
                console.warn('No count was supplied to generator.randomList(). Defaults to 5.');
                return 5;
            }
            return [...new Array(count)].map(() => this.randomContentOfType(key, includes));
        },
    };

    export default generator;



// WEBPACK FOOTER //
// ./src/helpers/generator.js